(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/use-disabled-draw.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/use-disabled-draw.js');
"use strict";


const {
  useEffect,
  useRef
} = React;
const {
  playContext
} = svs.racing_game.components;
const {
  dialog
} = svs.components;
const {
  navigation
} = svs.racing;
const FULL = 'FULL';
const showErrorMessage = (title, text) => {
  dialog.api.add(new dialog.Confirm({
    branding: dialog.branding.SPORT,
    icon: 'exclamation-sign',
    type: dialog.type.ERROR,
    title,
    message: [{
      type: dialog.message.TEXT,
      text
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.api.close();
      }
    }]
  }));
};
const useDisabledDraw = () => {
  const {
    race = {
      draws: []
    }
  } = React.useContext(playContext.PlayContext);
  const {
    gameType: currentGameType
  } = navigation.useNavigationState();
  const shownErrors = useRef(new Set());
  const disabledDraws = race.draws.filter(draw => draw.disabled);
  const drawsLength = race.draws.length;
  const errorType = disabledDraws.length === drawsLength ? FULL : currentGameType;
  const isCurrentGameTypeDisabled = disabledDraws.find(draw => draw.gameType === currentGameType);
  const isErrorShown = isCurrentGameTypeDisabled && !shownErrors.current.has(errorType);
  if (isErrorShown) {
    shownErrors.current.add(errorType);
  }
  useEffect(() => {
    for (const {
      disabled,
      gameType
    } of race.draws) {
      if (!disabled) {
        shownErrors.current.delete(gameType);
      }
    }
  }, [race.draws]);
  useEffect(() => {
    if (disabledDraws.length !== race.draws.length) {
      shownErrors.current.delete(FULL);
    }
  }, [race.draws.length, disabledDraws.length]);
  useEffect(() => {
    shownErrors.current.clear();
  }, [race.raceId]);
  useEffect(() => {
    if (!isErrorShown) {
      return;
    }
    const [title, text] = errorType === FULL ? ['Loppet är tillfälligt stängt', "Det h\xE4r loppet \xE4r just nu st\xE4ngt f\xF6r spel.\n        Vi f\xF6rs\xF6ker l\xF6sa problemet s\xE5 snart som m\xF6jligt."] : ['Loppet är delvis stängt för spel', "Just nu g\xE5r det inte att spela den spelform du har valt till det h\xE4r loppet.\n        Vi f\xF6rs\xF6ker l\xF6sa problemet s\xE5 snart som m\xF6jligt."];
    showErrorMessage(title, text);
  }, [isErrorShown, errorType, race.raceId]);
  return isCurrentGameTypeDisabled ? errorType : false;
};
svs.racing_game.components.play.useDisabledDraw = useDisabledDraw;
svs.racing_game.components.play.useDisabledDrawConstants = {
  FULLY_DISABLED_RACE: FULL
};

 })(window);